
// console.log(process.env.NODE_ENV, window.location.protocol);

const phpSaml = `${process.env.NODE_ENV == "development" ? `https://www.yallangany.com/simplesaml` : "https://www.yallangany.com/simplesaml"}`;
const hostName = `${process.env.NODE_ENV == "development" ? `http://${window.location.hostname}:3005/web/` : "https://www.yallangany.com/API/web/"}`;
const samlName = `${process.env.NODE_ENV == "development" ? `http://${window.location.hostname}:3005/saml/` : "https://www.yallangany.com/API/saml/"}`;
const hostImg = `${process.env.NODE_ENV == "development" ? `http://${window.location.hostname}:3005/` : "https://www.yallangany.com/API/"}`;
let Config = {
    
    key: "jJIyxe1P9fVfq3XgzZs12QIKIP1DMYzYo",
    php: phpSaml,
    domain: hostName,
    saml: samlName,
    appName: `"Rmobile"`,
    imgUrl: hostImg,
    uploadFolder:"Files/",

    pay_api_key: "9c12a91a195395bc7e7335b3d9938f87acc46112",
    pay_api_pass: "rmobile",
    pay_api_masof: "5601711420", 

    formatAllowed:"image/png,image/jpeg,image/gif,audio/mpeg"

}


export { Config }